// Local
// export const domain = "http://127.0.0.1:8000";
// export const domain_view = "http://127.0.0.1:8080";
// export const domain = "http://cbb.thaibiodiversity.org/";
// export const domain_view = "http://cbb.thaibiodiversity.org/";
// export const domain = "https://bedo-bank-admin.famikinnovation.com/";
// export const domain_view = "https://bedo-bank-admin.famikinnovation.com/";

export const domain = "https://bedo-bio-admin.ksta.co/";
export const domain_view = "https://bedo-bio-admin.ksta.co/";
